import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import useApiV2 from "../utils/useApiV2";

const dataValida = (data) =>
  data !== null && data !== undefined && data !== "" && data !== "Invalid Date";

const hora = (valor) => String(valor).padStart(2, "0");

export const janelaDoMapa = (startDate, endDate, selectedPeriod) => {
  const periodoValido =
    Array.isArray(selectedPeriod) &&
    selectedPeriod.length === 2 &&
    Number(selectedPeriod[1]) > Number(selectedPeriod[0]);
  if (periodoValido) {
    return {
      start: `${startDate}T${hora(selectedPeriod[0])}:00`,
      end: `${endDate}T${hora(selectedPeriod[1])}:00`,
    };
  }
  return { start: `${startDate}T00:00`, end: `${endDate}T23:59` };
};

export default function useHeatMap({
  selectedDateRange,
  selectedPeriod,
  isLastRecordPending,
  normalizationMode = "store",
  zoneScope = "all",
  viewMode = "3d",
  personScope = "todos",
}) {
  const { getHeatmap } = useApiV2();
  const { user } = useAuth();
  const branchId = user?.active_branch_id ?? null;
  const [startDate, endDate] = Array.isArray(selectedDateRange)
    ? selectedDateRange
    : [null, null];

  const { data, isLoading } = useQuery({
    queryKey: [
      "heatmapV2",
      user?.user_id ?? null,
      branchId,
      startDate,
      endDate,
      selectedPeriod,
      normalizationMode,
      zoneScope,
      viewMode,
      personScope,
    ],
    queryFn: async () => {
      const resposta = await getHeatmap({
        branch_id: branchId,
        ...janelaDoMapa(startDate, endDate, selectedPeriod),
        normalization_mode: normalizationMode,
        zone_scope: zoneScope,
        view: viewMode,
        person_scope: personScope,
      });
      if (!resposta?.image_base64) return null;
      return `data:${resposta.content_type};base64,${resposta.image_base64}`;
    },
    enabled:
      !isLastRecordPending &&
      Boolean(branchId) &&
      dataValida(startDate) &&
      dataValida(endDate),
    retry: false,
  });

  return { data, isLoading };
}
